// extracted by mini-css-extract-plugin
module.exports = {"list":"index__list___2Kfzc typography__paragraphLarge___2lmtJ typography__bodyFont___1exgA","listItem":"index__listItem___1tInr"};